import { DeliveryOrderApi } from '../../../api/Purchase/DeliveryOrder'
import DeliveryOrder from '../../../components/Purchasing/DeliveryOrder/DeliveryOrder'
import React from 'react'
import useFetchList from '../../../elements/Hooks/useFetchList'
import useTitle from '../../../elements/Hooks/useTitle'
import useListCompanyFilter from '../../../elements/Hooks/useListCompanyFilter'

function DeliveryOrderCont () {
  const { list: cached, fetching, fetch } = useFetchList(() => DeliveryOrderApi.list())
  const { list, company, onChangeCompany } = useListCompanyFilter(cached, fetching)
  useTitle('Delivery Order')

  return (
    <DeliveryOrder
      {...{
        list,
        fetching,
        fetch,
        company,
        onChangeCompany,
      }}
    />
  )
}

export default DeliveryOrderCont
